import Vue from 'vue'
import VueRouter from 'vue-router'// 路由

import homeView from '../views/home/index.vue'// 主页

import loginRegisterView from '../views/loginRegister/loginRegister.vue'// 登录注册页

import PrivacyPolicyView from '../views/loginRegister/PrivacyPolicy.vue'// 登录注册用户协议
import UserAgreementView from '../views/loginRegister/UserAgreement.vue'// 登录注册用户协议

import videoDownload from '../views/videoDownload/index.vue' // 视频下载

import audioProcessing from '../views/audio/audioAdjust.vue' // 音频处理

import videoTranslation from '../views/videoTranslation/index.vue' // 视频翻译

import stepwiseVideoTranslation from '../views/videoStepTransform/index.vue'// 精细视频翻译（分步视频翻译）

import videoDub from '../views/videoDubbing/index.vue'// 视频重新配音

import PayView from '../views/pay/paymentPage.vue' // 支付

import recodeView from '../views/backend/backend.vue' // 前端用户操作记录查询页

import PayRecode from '../views/payRecode/PayRecodePage.vue' // 后台管理系统页面 PayRecode

import store from '@/store'// 数据存储

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: homeView
  },
  {
    path: '/video-download',
    name: 'video-download',
    component: videoDownload
  },
  {
    path: '/audio-processing',
    name: 'audio-processing',
    component: audioProcessing
  },
  {
    path: '/video-translation',
    name: 'video-translation',
    component: videoTranslation
  },
  {
    path: '/stepwise-video-translation',
    name: 'stepwise-video-translation',
    component: stepwiseVideoTranslation
  },
  {
    path: '/video-dub',
    name: 'video-dub',
    component: videoDub
  },
  {
    path: '/recode',
    name: 'recode',
    component: recodeView
  },
  {
    path: '/loginRegister',
    name: 'loginRegister',
    component: loginRegisterView
  },
  {
    path: '/user-agreement',
    name: 'user-agreement',
    component: UserAgreementView
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicyView
  },
  {
    path: '/pay',
    name: 'pay',
    component: PayView
  },
  {
    path: '/pay-recode',
    name: 'pay-recode',
    component: PayRecode
  }
]

const router = new VueRouter({
  mode: 'history', // 关键配置：使用history模式而非默认的hash模式
  routes
})

// 所有的路由在真正被访问到之前(解析渲染对应组件页面前)，都会先经过全局前置守卫
// 只有全局前置守卫放行了，才会到达对应的页面

// 全局前置导航守卫
// to:   到哪里去，到哪去的完整路由信息对象 (路径，参数)
// from: 从哪里来，从哪来的完整路由信息对象 (路径，参数)
// next(): 是否放行
// (1) next()     直接放行，放行到to要去的路径
// (2) next(路径)  进行拦截，拦截到next里面配置的路径

// 定义一个数组，专门用户存放所有需要权限访问的页面 非权限页面，直接放行
const authUrls = ['/', '/video-download', '/audio-processing', '/video-translation', '/stepwise-video-translation',
  '/video-dub', '/recode', '/loginRegister', '/pay', '/privacy-policy', '/user-agreement', '/pay-recode'
]

router.beforeEach((to, from, next) => {
  // 看 to.path 是否在 authUrls 中出现过
  if (authUrls.includes(to.path)) {
    // 非权限页面，直接放行
    next()
    return
  }

  // 是权限页面，需要判断token
  const token = store.state.token
  if (token) {
    next() // 存在用户放行
  } else { // token不存在，拦截到登录页面
    next('/loginRegister')
  }
})

export default router
